import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PieComponent from '../components/PieComponent';
import * as c from '../constants';
import * as actions from '../actions';

function ServicesCount({ getCounts, counts, getENewsCounts, eNewsCounts }) {
  const { transactions } = counts;
  const { news_articles } = eNewsCounts;

  useEffect(() => {
    getCounts();
    getENewsCounts();
  }, []);

  const formatData = (data) => {
    if (!data) return [];
    return Object.keys(data).map((val) => {
      return { name: val, value: +data[val] };
    });
  };

  const renderLegends = (dt) =>
    dt.map((x) => (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    ));

  const eBillsData = formatData(
    c.E_BILLS.reduce((accumulator, current) => {
      return {
        ...accumulator,
        [current.name]: _.random(90, 200),
      };
    }, {})
  );

  const eCommerceData = formatData(
    c.E_COMMERCE.reduce((accumulator, current) => {
      return {
        ...accumulator,
        [current.name]: _.random(90, 200),
      };
    }, {})
  );

  const eServices = formatData(
    c.E_SERVICES.reduce((accumulator, current) => {
      return {
        ...accumulator,
        [current.name]: _.random(90, 200),
      };
    }, {})
  );

  return (
    <div className="row  pie">
      <div className="pie-wrapper col-md-2 ">
        <div className="pie-title">E-Government</div>
        <PieComponent chartData={formatData(transactions)} />
        <div className="legends-wrapper">{renderLegends(c.E_GOV_COLORS)}</div>
      </div>
      <div className="pie-wrapper col-md-2 ">
        <div className="pie-title">E-Bills Payment</div>
        {/* <div className="teaser-dash">Coming Soon</div> */}
        <PieComponent chartData={eBillsData} />
        <div className="legends-wrapper">{renderLegends(c.E_BILLS)}</div>
      </div>
      <div className="pie-wrapper col-md-2 ">
        <div className="pie-title">E-Commerce</div>
        {/* <div className="teaser-dash">Coming Soon</div> */}
        <PieComponent chartData={eCommerceData} />
        <div className="legends-wrapper">{renderLegends(c.E_COMMERCE)}</div>
      </div>
      <div className="pie-wrapper col-md-2 ">
        <div className="pie-title">E-Service</div>
        {/* <div className="teaser-dash">Coming Soon</div> */}
        <PieComponent chartData={eServices} />
        <div className="legends-wrapper">{renderLegends(c.E_SERVICES)}</div>
      </div>
      <div className="pie-wrapper col-md-2 ">
        <div className="pie-title">E-News</div>
        {/* <div className="teaser-dash">Coming Soon</div> */}
        <PieComponent chartData={formatData(news_articles)} />
        <div className="legends-wrapper">{renderLegends(c.E_NEWS)}</div>
      </div>
    </div>
  );
}

ServicesCount.defaultProps = {
  counts: {},
  eNewsCounts: {},
};

ServicesCount.propTypes = {
  getCounts: PropTypes.instanceOf(Function).isRequired,
  counts: PropTypes.instanceOf(Object),
  getENewsCounts: PropTypes.instanceOf(Object).isRequired,
  eNewsCounts: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  counts: _.get(api, `${c.GET_COUNTS}.res`),
  eNewsCounts: _.get(api, `${c.GET_ENEWS_COUNTS}.res`),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ServicesCount);
